define(["exports", "text!../../assets/datatype.css"], function (_exports, _datatype) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.run = run;
  _exports.name = void 0;
  _datatype = _interopRequireDefault(_datatype);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  // @ts-check

  /**
   * Module core/data-type
   * Propagates data type of a <var> to subsequent instances within a section.
   * Also adds the CSS for the data type tooltip.
   * Set `conf.highlightVars = true` to enable.
   */
  const name = "core/data-type";
  _exports.name = name;

  function run(conf) {
    if (!conf.highlightVars) {
      return;
    }

    const style = document.createElement("style");
    style.textContent = _datatype.default;
    document.head.appendChild(style);
    let section = null;
    const varMap = new Map();
    /** @type {NodeListOf<HTMLElement>} */

    const variables = document.querySelectorAll("section var");

    for (const varElem of variables) {
      const currentSection = varElem.closest("section");

      if (section !== currentSection) {
        section = currentSection;
        varMap.clear();
      }

      if (varElem.dataset.type) {
        varMap.set(varElem.textContent.trim(), varElem.dataset.type);
        continue;
      }

      const type = varMap.get(varElem.textContent.trim());
      if (type) varElem.dataset.type = type;
    }
  }
});
//# sourceMappingURL=data-type.js.map